import {
  BookOpenIcon,
  MapIcon,
  QuestionMarkCircleIcon,
} from "@heroicons/react/20/solid";
import { RecordScreen } from "@/lib/Components/Screens/RecordScreen/RecordScreen";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { useTripRecord } from "@/app/Cities/Trips/Hooks/useTripRecord";
import { tripName } from "@/app/Cities/Trips/Utils/tripName";

export function TripRecordScreen() {
  const trip = useTripRecord();

  return (
    <RecordScreen
      title={tripName(trip)}
      breadcrumbs={
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink
                from="/$tenant/$orgId/supplier/{-$supplierId}"
                to="/$tenant/$orgId/supplier/{-$supplierId}/admin/trips"
                params={(prev) => prev}
              >
                Trips
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>{tripName(trip)}</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      }
      tabParams={{ tripId: trip.id }}
      tabs={[
        {
          name: "Details",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/admin/trips/$tripId",
          Icon: MapIcon,
        },
        {
          name: "FAQs",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/admin/trips/$tripId/faqs",
          Icon: QuestionMarkCircleIcon,
          notificationCount: trip.faqs.length,
        },
        {
          name: "Articles",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/admin/trips/$tripId/articles",
          Icon: BookOpenIcon,
        },
      ]}
    />
  );
}
